<template>
    <div class="status-badge-wrapper flex">
        <div
            v-if="selectedStatus"
            class="flex md:py-1 px-3 rounded-full font-semibold outline outline-2"
            :class="[selectedStatus.textColorClass, selectedStatus.bgColorClass, selectedStatus.borderColorClass]"
        >
            <img
                v-if="selectedStatus.icon"
                class="-ml-1 mr-2"
                :src="global.app.url + '/images/icons/status/' + selectedStatus.icon + '.svg'"
            />
            {{ selectedStatus.label }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "StatusBadgeComponent",
    props: {
        status: { type: String, default: "" }, // Sets the "status" for the badge
    },
    components: {},
    computed: {
        ...mapGetters(["global", "collections"])
    },
    mounted() {
        this.getStatus();
    },
    data: function () {
        return {
            selectedStatus: false,
        };
    },
    methods: {
        getStatus() {
            // Basic check to see if the status passed in via a prop exists as a valid status that we're expecting
            if (this.collections.submission_statuses[this.status] != undefined) {
                this.selectedStatus = this.collections.submission_statuses[this.status];
                this.selectedStatus.label = this.status;
            }
        },
    },
    watch: {
        status() {
            this.getStatus();
        }
    }
};
</script>
